/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosPromise, AxiosRequestConfig, Method } from 'axios';
import humps from 'humps';
import qs from 'qs';

const instance = axios.create({
  // baseURL: `${process.env.REACT_APP_API_URL || 'https://cms.belle.ai/wp-json/torus-data/v1'}`,
  transformResponse: [
    ...(axios.defaults.transformResponse as []),
    (data: any) => humps.camelizeKeys(data),
  ],
  transformRequest: [
    (data: any) => humps.decamelizeKeys(data),
    ...(axios.defaults.transformRequest as []),
  ],
  paramsSerializer(params: any) {
    if (!params) return params;
    return qs.stringify(humps.decamelizeKeys(params), {
      arrayFormat: 'brackets',
    });
  },
});

const instanceNoTransform = axios.create({
  // baseURL: `${process.env.REACT_APP_API_URL || 'https://cms.belle.ai/wp-json/torus-data/v1'}`,
  transformResponse: [...(axios.defaults.transformResponse as []), (data: any) => data],
  transformRequest: [
    (data: any) => humps.decamelizeKeys(data),
    ...(axios.defaults.transformRequest as []),
  ],
  paramsSerializer(params: any) {
    if (!params) return params;
    return qs.stringify(humps.decamelizeKeys(params), {
      arrayFormat: 'brackets',
    });
  },
});

export class ServiceCMS {
  public async call(
    method: Method,
    baseUrl: string,
    url: string,
    body: any,
    token?: string,
    noTransform?: boolean,
  ) {
    let config: AxiosRequestConfig = {};

    if (token) {
      config = {
        url: baseUrl + url,
        method: method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: body,
      };
    } else {
      config = {
        url: baseUrl + url,
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        data: body,
      };
    }

    return new Promise((reslove, reject) => {
      this.instanceAxios(config, noTransform)
        .then(({ data }) => {
          // console.log(data);
          reslove(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  private instanceAxios(config: AxiosRequestConfig, noTransform?: boolean): AxiosPromise {
    if (noTransform) {
      return instanceNoTransform(config);
    }

    return instance(config);
  }
}

export default instance;
